import React, { useState, useEffect } from 'react';
import Loading from '../general/Loading';
import { useNavigate } from 'react-router-dom';

const AddPurchase = ({setResponse}) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    partyId: '',
    date: '',
    paymentMethod: '',
    amountPaid: '',
    totalAmount: 0,
    items: [{ itemId: '', quantity: 1 }]
  });

  const [parties, setParties] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetch('https://api.siddhabhairabistore.com/get-party').then(res => res.json()),
      fetch('https://api.siddhabhairabistore.com/get-product').then(res => res.json())
    ])
      .then(([partyData, productData]) => {
        setParties(partyData);
        setItems(productData);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);


  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

const handleItemChange = (index, field, value) => {
  const updatedItems = [...formData.items];
  updatedItems[index][field] = field === 'quantity' ? parseInt(value, 10) : value;

  // Recalculate totalAmount
  const total = updatedItems.reduce((sum, item) => {
    const selectedItem = items.find(i => i.id == item.itemId);
    const price = selectedItem?.purchase_price || 0;
    console.log(`Price ${price} ${selectedItem}`);
    return sum + price * item.quantity;
  }, 0);

  setFormData(prev => ({
    ...prev,
    items: updatedItems,
    totalAmount: total
  }));
};

const addItemField = () => {
  const updatedItems = [...formData.items, { itemId: '', quantity: 1 }];
  setFormData(prev => ({
    ...prev,
    items: updatedItems
  }));
};

const removeItemField = (index) => {
  const updatedItems = formData.items.filter((_, i) => i !== index);

  const total = updatedItems.reduce((sum, item) => {
    const selectedItem = items.find(i => i.id == item.itemId);
    const price = selectedItem?.purchase_price || 0;
    return sum + price * item.quantity;
  }, 0);

  setFormData(prev => ({
    ...prev,
    items: updatedItems,
    totalAmount: total
  }));
};


const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const res = await fetch('https://api.siddhabhairabistore.com/add-purchase', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    if (!res.ok) throw new Error('Failed to add purchase');

    setFormData({
      partyId: '',
      date: '',
      paymentMethod: '',
      amountPaid: '',
      totalAmount: 0,
      items: [{ itemId: '', quantity: 1 }]
    });

    setResponse({ message: 'Purchase Bill Added successfully.', status: 'success' });
    setTimeout(() => setResponse(''), 2000);
  } catch (error) {
    console.error(error);
    setResponse({ message: 'Failed to add purchase.', status: 'error' });
    setTimeout(() => setResponse(''), 2000);
  } finally {
    setLoading(false);
  }
};


  return (
    <>
      <section className="my-4">
        <div className="px-4">
          <p className="page-title">Add Purchase</p>


          <form className="row g-3 bg-white rounded-2 mt-2 px-3" onSubmit={handleSubmit}>

<div className='text-end'>
  <button className='edit-btn px-3 py-1' onClick={() => navigate('/add-party')}>Add Party</button>&nbsp;&nbsp;
          <button className='edit-btn px-3 py-1' onClick={() => navigate('/add-product')}>+ New Item</button></div>

            <div className="col-md-12">
              <label className="profile-label">Date</label><br />
              <input
                type="date"
                className="product-control col-3"
                value={formData.date}
                onChange={e => handleInputChange('date', e.target.value)}
                required
              />
            </div>

            <div className="col-md-12">
              <label className="profile-label">Party</label><br />
              <select
                className="product-control col-3"
                value={formData.partyId}
                onChange={e => handleInputChange('partyId', e.target.value)}
                required
              >
                <option value="">Select Party</option>
                {parties.map(party => (
                  <option key={party.id} value={party.id}>{party.name}</option>
                ))}
              </select>
            </div>

            <div className="col-12 mt-4">
              <div className="row fw-semibold mb-1">
                <div className="profile-label col-md-5">Item</div>
                <div className="profile-label col-md-2">Qty</div>
                <div className="profile-label col-md-2">Price/Unit</div>
                <div className="profile-label col-md-2">Amount</div>
              </div>

              {formData.items.map((item, index) => {
                const selectedItem = items.find(i => i.id == item.itemId);
                const itemPrice = selectedItem?.purchase_price || 0;

                return (
                  <div className="row mb-2" key={index}>
                    <div className="col-md-5">
                      <select
                        className="product-control"
                        value={item.itemId}
                        onChange={e => handleItemChange(index, 'itemId', e.target.value)}
                        required
                      >
                        <option value="">Select Item</option>
                        {items.map(i => (
                          <option key={i.id} value={i.id}>{i.name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-2">
                      <input
                        type="number"
                        min="1"
                        className="product-control"
                        value={item.quantity}
                        onChange={e => handleItemChange(index, 'quantity', e.target.value)}
                        required
                      />
                    </div>

                    <div className="col-md-2">
                      <input
                        type="number"
                        className="product-control"
                        value={itemPrice}
                        readOnly
                      />
                    </div>

                    <div className="col-md-2">
                      <input
                        type="number"
                        className="product-control"
                        value={itemPrice * item.quantity}
                        readOnly
                      />
                    </div>

                    <div className="col-md-1">
    <button
      type="button"
      className="btn btn-sm btn-danger"
      onClick={() => removeItemField(index)}
      disabled={formData.items.length === 1}
    >
      ×
    </button>
  </div>
                  </div>
                );
              })}

              <button type="button" className="edit-btn px-3 py-1" onClick={addItemField}>Add +</button>
            </div>

            <div className="col-md-9">
              <label className="profile-label">Payment Method</label><br />
              <select
                className="product-control col-3"
                value={formData.paymentMethod}
                onChange={e => handleInputChange('paymentMethod', e.target.value)}
                required
              >
                <option value="">Select Payment Method</option>
                <option value="Cash">Cash</option>
                <option value="UPI">UPI</option>
                <option value="Credit Card">Credit Card</option>
                <option value="Debit Card">Debit Card</option>
              </select>

<br />

              <label className="profile-label mt-2 text-danger">Due Amount</label><br />
<input
  type="number"
  className="product-control col-3"
  value={Math.max(formData.totalAmount - Number(formData.amountPaid || 0), 0)}
  readOnly
/>

            </div>

            <div className="col-md-3">
              <label className="profile-label">Total Amount</label><br />
              <input
                type="number"
                className="product-control"
                value={formData.totalAmount}
                readOnly
              />

              <label className="profile-label mt-2 text-success">Amount Paid</label><br />
              <input
                type="number"
                className="product-control"
                value={formData.amountPaid}
                onChange={e => handleInputChange('amountPaid', e.target.value)}
                required
              />

            </div>

            <div className="col-12 text-end">
              <button type="submit" className="edit-btn">Save Bill</button>
            </div>
          </form>
        </div>
      </section>

      {loading && <Loading setLoading={setLoading} />}
    </>
  );
};

export default AddPurchase;
